import { createSlice } from "@reduxjs/toolkit";
import { ToastType } from "@src/@types/ToastAlert";

const INITIAL_STARTE: ToastType = {
  type: "success",
  show: false,
  children: "",
};

const restoreAlert = (): ToastType => {
  return INITIAL_STARTE;
};

export const toastSlice = createSlice({
  name: "toastSlice",
  initialState: {
    toast: restoreAlert(),
  },
  reducers: {
    handleShowAlert: (state, action) => {
      let payload = action.payload;
      payload.show = true;
      state.toast = action.payload;
    },
    handleCloseAlert: (state) => {
      let payload = state.toast;
      payload.show = false;
      state.toast = payload;
    },
  },
});
export const { handleShowAlert, handleCloseAlert } = toastSlice.actions;

export default toastSlice.reducer;
